import store from '../../../store';
import {fetchStep, nextStep, fetchService} from '../../../actions/steps';
import {setError} from '../../../actions/progress';
import {runStepValidations} from './validation';

/**
 * A shared function used to submit a step and move on to the next
 *
 * The `stepHandle` provided should be the current step handle which
 * the user is currently working on. This is what the server uses
 * to determine where they should go next.
 *
 * The `inputHandle` and `inputValue` are optional, but if one is
 * provided then both should be provided. They should be used when
 * the input drives the next step not the step itself. This is for
 * questions with `dynamic: 'step'`
 *
 * @param stepHandle
 * @param inputHandle
 * @param inputValue
 */
export function submitStep(stepHandle, inputHandle, inputValue) {
  const {
    progress: {stepIds},
  } = store.getState();
  const stepIndex = stepIds.indexOf(stepHandle);
  const isDynamic = Boolean(inputHandle || inputValue);
  const isNextStepPresent = stepIndex + 1 < stepIds.length;

  if (runStepValidations(stepHandle)) {
    if (!isDynamic && isNextStepPresent) {
      store.dispatch(nextStep());
    } else {
      store
        .dispatch(fetchStep(stepHandle, inputHandle, inputValue))
        .then(store.dispatch(nextStep()))
        .catch(
          handleError.bind({
            message: 'Unable to fetch the next step. Please try again shortly.',
          })
        );
    }
  }
}

export function submitServiceSelection(serviceHandle) {
  store.dispatch(fetchService(serviceHandle)).catch(
    handleError.bind({
      message: 'Unable to fetch the service. Please try again shortly.',
    })
  );
}

function handleError(error) {
  store.dispatch(setError(error));
}
